/**
 * FilterGroup Komponenti
 * 
 * Sidebar filtreleri için genel filtre grubu wrapper'ı
 * Her grup ayrı kart içinde gösterilir (Figma tasarımına göre)
 * Collapsible/expandable yapı, açılır/kapanır animasyonu
 */

'use client'

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

export interface FilterGroupProps {
    title: string
    children: React.ReactNode
    defaultOpen?: boolean
    className?: string
}

export default function FilterGroup({
    title,
    children,
    defaultOpen = true,
    className = '',
}: FilterGroupProps) {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    return (
        <div className={`bg-white border border-[#E7EBF3] rounded-lg p-6 mb-4 last:mb-0 ${className}`}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between py-2 text-left group"
                aria-expanded={isOpen}
            >
                <h3 className="text-lg font-semibold text-alsero-dark-gray group-hover:text-alsero-first transition-colors">
                    {title}
                </h3>
                <motion.svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-alsero-dark-gray group-hover:text-alsero-first transition-colors"
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.2 }}
                >
                    <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </motion.svg>
            </button>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="overflow-hidden"
                    >
                        <div className="pt-4">{children}</div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}
